import React from "react";

interface TabsProps {
  tabs: string[];
  activeTab: number;
  onTabClick: (idx: number) => void;
  className?: string;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabClick,
  className = "",
}) => (
  <div
    className={`flex flex-col border-b border-gray-200 dark:border-gray-700 mb-6 mt-10 ${className}`}
  >
    <nav className="-mb-px flex space-x-8" aria-label="Tabs">
      {tabs.map((tab, idx) => (
        <button
          key={tab}
          className={`whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm focus:outline-none ${
            activeTab === idx
              ? "border-indigo-600 text-indigo-700 dark:text-indigo-300"
              : "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          }`}
          onClick={() => onTabClick(idx)}
          aria-current={activeTab === idx ? "page" : undefined}
          type="button"
        >
          {tab}
        </button>
      ))}
    </nav>
  </div>
);

export default Tabs;
